import { DialogTitle } from '@radix-ui/react-dialog';
import { Button } from 'components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTrigger,
} from 'components/ui/dialog';
import { Input } from 'components/ui/input';
import { Pencil } from 'lucide-react';
import { useState } from 'react';

export default function EditModal({
  title,
  id,
  handleUpdate,
}: {
  title: string;
  id: number;
  handleUpdate?: (e: any, id: number, fileName: string) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [fileName, setFileName] = useState(title);

  return (
    <div>
      <Dialog
        open={isOpen}
        onOpenChange={(e) => {
          setIsOpen(e);
        }}
      >
        <DialogTrigger asChild>
          <button className="px-1 lg:px-2 w-full py-2 rounded-md text-primary lg:text-white flex  items-center  gap-3">
            <Pencil size={16} />
            <span className="block lg:hidden text-text-primary">Edit</span>
          </button>
        </DialogTrigger>
        <DialogContent className="text-text-primary">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold">Edit</DialogTitle>
          </DialogHeader>
          <form>
            <div className="flex flex-col gap-2">
              <label htmlFor="fileName">Gif Url</label>
              <Input
                name="fileName"
                value={fileName}
                onChange={(e) => {
                  const { value } = e.target;
                  setFileName(value);
                }}
                type="text"
              />
            </div>
            <DialogFooter className="mt-4 gap-2">
              <Button
                onClick={() => {
                  setIsOpen(false);
                }}
                variant={'customSecondary'}
                size={'sm'}
                type="button"
                className="bg-secondary"
              >
                Cancel
              </Button>
              <Button
                onClick={(e) => handleUpdate?.(e, id, fileName)}
                variant="customSecondary"
                size={'sm'}
                className="bg-secondary"
              >
                Save & Continue
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
}
